import { StartupFunction } from ".";

export const themeStartup: StartupFunction = (root) => {
  const { store, commands } = root;
  store.dispatch(commands.themeCommands.loadCurrentTheme());
}
